import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JSX Modules
import FilterSelectorsMixin from './filter-selectors-mixin';

// -----------------------------------------------------------
//  FilterImageCriteron
// -----------------------------------------------------------
const FilterImageCriteron = createReactClass({
  mixins: [FilterSelectorsMixin],
  render() {
    return (
      <button
        className={classNames('btn selector square', { selected: this.props.selected, disabled: this.props.disabled })}
        ref='option'
        aria-disabled={this.props.disabled}
        aria-label={this.props.title}
        aria-pressed={this.props.selected}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleSelected}
      >
        <img src={this.props.image} className="img-fluid mx-auto" alt={this.props.title} />
        {this.disabledOverlay()}
      </button>
    );
  }
});

export default FilterImageCriteron;
